import { render } from "./AppLoader.vue?vue&type=template&id=077cc31f&scoped=true"
const script = {}

import "./AppLoader.vue?vue&type=style&index=0&id=077cc31f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077cc31f"]])

export default __exports__